/**
 * @description: 预定单详情
 * @author: hwx
 */
<template>
	<div class="book-detail-wrap">
		<div class="page-tit">预定单详情</div>
		<div class="bkd-con clearfix">
            <div class="col-md-5">
                <label class="col-md-3">订单编号：</label>
                <span class="col-md-9">{{theOrder.id}}</span>
                <label class="col-md-3">客户昵称：</label>
                <span class="col-md-9">{{theOrder.ahead_user_name}}</span>
                <label class="col-md-3">下单时间：</label>
                <span class="col-md-9">{{theOrder.timestamp}}</span>
                <label class="col-md-3">消费包厢：</label>
                <span class="col-md-9">{{theOrder.room_name}}</span>
                <label class="col-md-3">套餐名称：</label>
                <span class="col-md-9">{{theOrder.title}}</span>
            </div>
            <div class="col-md-5">
                <label class="col-md-3">实收金额：</label>
                <span class="col-md-9">{{theOrder.actual_pay}}元</span>
                <label class="col-md-3">消费金额：</label>
                <span class="col-md-9">{{theOrder.preferential_price}}元</span>
                <label class="col-md-3">支付类型：</label>
                <span class="col-md-9">{{theOrder.pay_platform_show}}</span>
                <label class="col-md-3">支付状态：</label>
                <span class="col-md-9">{{theOrder.status_show}}</span>
                <label class="col-md-3">状态：</label>
                <span class="col-md-9">{{theOrder.use_status}}</span>
            </div>
        </div>
        <div class="row onedash">
            <div class="col-md-5">
                <label class="col-md-3">预定详情：</label>
                <span class="col-md-9">{{theOrder.book_info}}</span>
            </div>
        </div>
        <div class="row onedash">
            <div class="col-md-5">
                <label class="col-md-3">会员卡：</label>
                <span class="col-md-9" v-if="theOrder.vip_card != ''">已使用</span>
                <span class="col-md-9" v-if="theOrder.vip_card == ''">未使用</span>
            </div>
        </div>
        <div class="title" style="margin-bottom: 30px;">消费商品</div>
        <div class="table-responsive" style="padding: 0;margin-bottom:30px">
            <table id="consume-goods-table" class="table table-bordered table-hover" data-pagination="true" ref="consumegoods"></table>
        </div>
        <div class="book-det-refund">
            <div class="title" style="margin-bottom: 30px;">退货退款操作日志</div>
            <div class="table-responsive" style="padding: 0;margin-bottom:30px">
                <table id="refund_table" class="table table-bordered table-hover" data-pagination="true" ref="refund_table"></table>
            </div>
        </div>
		<div>
			<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="$emit('backBkdPre')">返回</button>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: '',
		data() {
			return {
				theOrder: {
					type: Object
				},
				theGoods: [],
				theRefund: [],
			}
		},
		mounted: function() {},
		methods: {
			// 详情
			getBkdDetail: function(id) {
                const _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Book/getDetail",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        _this.theOrder = data.response.result.order_info;
						_this.theGoods = data.response.result.goods_info;
						$(_this.$refs.consumegoods).bootstrapTable("destroy");
						_this.innitGoodsTable();
						// 退款退货
						_this.theRefund = data.response.result.refund_info;
						if(_this.theRefund.length == 0) {
							$('.book-det-refund').hide();
						} else {
							$(_this.$refs.refund_table).bootstrapTable("destroy");
							_this.innitRefundTable();
							$('.book-det-refund').show();
						}
					},
				    error: function(err) {
						layer.msg("出错啦");
				    }
				});
			},
			// 初始化商品表格
			innitGoodsTable: function() {
				let _this = this;
				$(_this.$refs.consumegoods).bootstrapTable({
					pagination: false,
					columns: [{
						field: "goods_name",
						title: "商品名称",
						width: "33%"
					}, {
						field: "quantity",
						title: "商品数量",
						width: "33%",
						formatter: function(value, row) {
							return row.quantity + row.goods_unit_name;
						}
					}, {
						field: "actual_amount",
						title: "商品价格",
						width: "33%"
					}],
					data: _this.theGoods
				});
			},
			// 初始化退货退款表格
			innitRefundTable: function() {
				let _this = this;
				$(_this.$refs.refund_table).bootstrapTable({
					pagination: false,
					columns: [{
						field: "time",
						title: "操作时间",
						width: '30%'
					}, {
						field: "operator",
						title: "操作人",
						width: '30%'
					}, {
						field: "detail",
						title: "详情",
						width: '40%',
						formatter: function(value, row) {
							return '<p>退款：'+row.refund_amount+'元</p><p>退款原因：'+row.refund_reason+'</p>'
						}
					}],
					data: _this.theRefund
				});
			},
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.book-detail-wrap {
		.bkd-con {
			margin: 20px 0 40px;
		}
		.title {
			height: 20px;
			width: 100%;
			margin: 30px 0 30px 0px;
			line-height: 20px;
			font-size: 18px;
		}
		.col-md-5 {
			padding-left: 0;
			font-size: 14px;
			>label {
				height: 40px;
				line-height: 40px;
				padding: 0;
				margin-bottom: 0px;
			}
			>span {
				min-height: 40px;
				padding-left: 0;
				margin: 9px 0 0;
				line-height: 23px;
			}
		}
		.onedash {
			border-top: 1px dashed #e4e4e4;
		}
	}
</style>